import React from "react";

const Groups = () => <div />;
export default Groups;
